import axios from 'axios';
import {actions} from '../reducers/UsersActionsTableReducer';

export const GET_USERS_ACTIONS = 'activityLogs/getList';
export const GET_USERS_ACTIONS_EXCEL = 'activityLogs/getListForExcel';

export const getUsersActionsList = action => ({
                                                responsibleUserID = -1,
                                                page = '',
                                                subject = '',
                                                actionID = -1,
                                                statusID = -1,
                                                sourceID = -1,
                                                createdFromDate = '',
                                                createdToDate = '',
                                                requestedPageNumber = 0,
                                                sortByField = 'createTime',
                                                sortByOrder = -1
                                              }) => dispatch => {

  const data = {
    responsibleUserID: parseInt(responsibleUserID, 10),
    page,
    subject,
    actionID: parseInt(actionID, 10),
    statusID: parseInt(statusID, 10),
    sourceID: parseInt(sourceID, 10),
    createdFromDate,
    createdToDate,
    requestedPageNumber: parseInt(requestedPageNumber, 10),
    sortByField,
    sortByOrder: parseInt(sortByOrder, 10),
  };

  return axios.post(GET_USERS_ACTIONS, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();
      const {
        totalPageCount,
        currentPageNumber,
        list,
        totalResultCount
      } = body;

      dispatch(action({
        totalPageCount,
        currentPageNumber,
        usersActions: list,
        totalResultCount,
      }));
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError(error));
    });
};

export const getUsersActions = getUsersActionsList(actions.usersActionsFetched);
export const getNextUsersActions = getUsersActionsList(actions.usersActionsAppended);

export const getUsersActionsListForExcel = ({
                                              responsibleUserID = -1,
                                              page = '',
                                              subject = '',
                                              actionID = -1,
                                              statusID = -1,
                                              sourceID = -1,
                                              createdFromDate = '',
                                              createdToDate = '',
                                              sortByField = 'createTime',
                                              sortByOrder = -1
                                            }) => dispatch => {
  const data = {
    responsibleUserID: parseInt(responsibleUserID, 10),
    page,
    subject,
    actionID: parseInt(actionID, 10),
    statusID: parseInt(statusID, 10),
    sourceID: parseInt(sourceID, 10),
    createdFromDate,
    createdToDate,
    sortByField,
    sortByOrder: parseInt(sortByOrder, 10),
  };
  return axios.post(GET_USERS_ACTIONS_EXCEL, data)
    .then(response => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error();

      return body.list;
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError(error));
    });
};